import {
  canPlayerSwapMission,
  getActivePlayerIndex,
  getPlayerDisplayName,
} from '../../domain/phaseStatus';
import { MISSION_BY_ID } from '../../data/missions';
import { HUMAN_PLAYER_INDEX } from '../../domain/types';
import { useGameStore } from '../../store/gameStore';

export function StickyActionBar() {
  const game = useGameStore((s) => s.game);
  const dispatch = useGameStore((s) => s.dispatch);
  const botActingPlayerIndex = useGameStore((s) => s.botActingPlayerIndex);
  const { phase, players } = game;
  const human = players[HUMAN_PLAYER_INDEX];

  if (phase === 'setup' || phase === 'game_over') return null;

  const actorIndex = getActivePlayerIndex(game);
  const actorName = getPlayerDisplayName(game, actorIndex);

  const isHumanActive =
    human &&
    ((phase === 'mission_draft' && actorIndex === HUMAN_PLAYER_INDEX) ||
      (phase === 'mission_select' && actorIndex === HUMAN_PLAYER_INDEX) ||
      (phase === 'betting' && actorIndex === HUMAN_PLAYER_INDEX) ||
      (phase === 'draft' && actorIndex === HUMAN_PLAYER_INDEX) ||
      (phase === 'settlement' && actorIndex === HUMAN_PLAYER_INDEX));

  const isBotWaiting =
    !isHumanActive &&
    !['round_roll', 'game_over', 'setup'].includes(phase) &&
    botActingPlayerIndex === null;

  const canSwapMission =
    phase === 'draft' &&
    isHumanActive &&
    canPlayerSwapMission(game, HUMAN_PLAYER_INDEX);

  return (
    <div className="overlay-panel p-3">
      {phase === 'round_roll' && (
        <button
          type="button"
          className="overlay-button-primary min-h-[44px] w-full"
          onClick={() => dispatch({ type: 'ROLL_DICE' })}
        >
          주사위 굴리기
        </button>
      )}

      {phase === 'settlement' && actorIndex === HUMAN_PLAYER_INDEX && human?.selectedMissionId && (
        <button
          type="button"
          className="overlay-button-primary min-h-[44px] w-full"
          onClick={() => dispatch({ type: 'SETTLEMENT_REVEAL', playerIndex: HUMAN_PLAYER_INDEX })}
        >
          미션 공개: {MISSION_BY_ID[human.selectedMissionId]?.name ?? human.selectedMissionId}
        </button>
      )}

      {isHumanActive && canSwapMission && (
        <p className="text-center text-sm text-white/75">
          미션 메뉴에서 미사용 미션을 탭해 교체하거나, 아래에서 주사위를 배치하세요
        </p>
      )}

      {isHumanActive &&
        ['mission_draft', 'mission_select', 'betting', 'draft'].includes(phase) &&
        !canSwapMission && (
          <p className="text-center text-sm text-white/75">아래 패널에서 선택해 주세요</p>
        )}

      {isBotWaiting && (
        <p className="text-center text-sm text-amber-200/80">{actorName} 차례…</p>
      )}
    </div>
  );
}
